"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.svgBWData = exports.svgData = exports.youtubeBW = exports.mailBW = exports.twitterBW = exports.linkedinBW = exports.instagramBW = exports.facebookBW = exports.label = exports.youtube = exports.linkedin = exports.instagram = exports.twitter = exports.facebook = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var facebook = function facebook() {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: "11",
    height: "20",
    viewBox: "0 0 11 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.4254 0.00416133L7.82696 0C4.90772 0 3.02118 1.9319 3.02118 4.92203V7.19141H0.408577C0.182818 7.19141 0 7.37409 0 7.59943V10.8875C0 11.1128 0.183026 11.2953 0.408577 11.2953H3.02118V19.5922C3.02118 19.8175 3.20399 20 3.42975 20H6.83845C7.06421 20 7.24703 19.8173 7.24703 19.5922V11.2953H10.3018C10.5275 11.2953 10.7103 11.1128 10.7103 10.8875L10.7116 7.59943C10.7116 7.49123 10.6684 7.38762 10.5919 7.31105C10.5154 7.23448 10.4112 7.19141 10.3028 7.19141H7.24703V5.26763C7.24703 4.34298 7.46778 3.87358 8.67455 3.87358L10.425 3.87295C10.6505 3.87295 10.8333 3.69027 10.8333 3.46514V0.411972C10.8333 0.187052 10.6507 0.00457747 10.4254 0.00416133Z",
    fill: "#262F56"
  }));
};

exports.facebook = facebook;

var twitter = function twitter() {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: "26",
    height: "20",
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M25.9893 2.36631C25.0691 2.76787 24.0818 3.0402 23.0445 3.16178C24.1037 2.5371 24.9145 1.54627 25.2987 0.369248C24.3052 0.947741 23.2085 1.3678 22.0399 1.59551C21.1042 0.612368 19.7732 0 18.2969 0C15.4646 0 13.1682 2.26171 13.1682 5.04962C13.1682 5.44501 13.2135 5.8312 13.301 6.20049C9.03927 5.98967 5.2603 3.97877 2.73109 0.923119C2.28897 1.66781 2.03746 2.53553 2.03746 3.46179C2.03746 5.21424 2.94355 6.76051 4.31831 7.66517C3.47782 7.63749 2.68734 7.40978 1.99531 7.03128V7.09436C1.99531 9.54069 3.76373 11.5824 6.10859 12.0471C5.67897 12.1609 5.22595 12.224 4.75728 12.224C4.42611 12.224 4.10585 12.1917 3.79184 12.1301C4.44482 14.138 6.33824 15.5981 8.58159 15.6381C6.82722 16.9921 4.61512 17.7967 2.21246 17.7967C1.79849 17.7967 1.39073 17.7721 0.989258 17.7275C3.25916 19.163 5.95397 20 8.8503 20C18.2845 20 23.4413 12.304 23.4413 5.62968L23.4241 4.97579C24.4317 4.26799 25.3034 3.37871 25.9893 2.36631Z",
    fill: "#262F56"
  }));
};

exports.twitter = twitter;

var instagram = function instagram() {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: "21",
    height: "20",
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M0.224609 9C0.224609 5.25027 0.224609 3.3754 1.17952 2.06107C1.48792 1.6366 1.86121 1.26331 2.28568 0.954915C3.60001 0 5.47488 0 9.22461 0H11.2246C14.9743 0 16.8492 0 18.1635 0.954915C18.588 1.26331 18.9613 1.6366 19.2697 2.06107C20.2246 3.3754 20.2246 5.25027 20.2246 9V11C20.2246 14.7497 20.2246 16.6246 19.2697 17.9389C18.9613 18.3634 18.588 18.7367 18.1635 19.0451C16.8492 20 14.9743 20 11.2246 20H9.22461C5.47488 20 3.60001 20 2.28568 19.0451C1.86121 18.7367 1.48792 18.3634 1.17952 17.9389C0.224609 16.6246 0.224609 14.7497 0.224609 11V9ZM10.2226 4.7058C7.29887 4.7058 4.92843 7.07625 4.92843 9.99992C4.92843 12.9236 7.29887 15.294 10.2226 15.294C13.1462 15.294 15.5167 12.9236 15.5167 9.99992C15.5167 7.07625 13.1462 4.7058 10.2226 4.7058ZM10.2226 13.3087C8.39873 13.3087 6.91373 11.8237 6.91373 9.99992C6.91373 8.17478 8.39873 6.6911 10.2226 6.6911C12.0464 6.6911 13.5314 8.17478 13.5314 9.99992C13.5314 11.8237 12.0464 13.3087 10.2226 13.3087ZM16.622 4.30854C16.622 4.69814 16.3062 5.01398 15.9166 5.01398C15.527 5.01398 15.2111 4.69814 15.2111 4.30854C15.2111 3.91893 15.527 3.6031 15.9166 3.6031C16.3062 3.6031 16.622 3.91893 16.622 4.30854Z",
    fill: "#262F56"
  }));
};

exports.instagram = instagram;

var linkedin = function linkedin() {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: "21",
    height: "20",
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.2278 20.0002V19.9993H20.2328V12.6647C20.2328 9.07653 19.4604 6.3125 15.2656 6.3125C13.249 6.3125 11.8957 7.41911 11.3433 8.46823H11.2849V6.64748H7.30762V19.9993H11.4491V13.388C11.4491 11.6472 11.7791 9.96399 13.9348 9.96399C16.0589 9.96399 16.0905 11.9506 16.0905 13.4997V20.0002H20.2278Z",
    fill: "#262F56"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M0.56543 6.64648H4.7119V19.9983H0.56543V6.64648Z",
    fill: "#262F56"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M2.63397 0C1.3082 0 0.232422 1.07578 0.232422 2.40155C0.232422 3.72732 1.3082 4.8256 2.63397 4.8256C3.95974 4.8256 5.03552 3.72732 5.03552 2.40155C5.03469 1.07578 3.95891 0 2.63397 0V0Z",
    fill: "#262F56"
  }));
};

exports.linkedin = linkedin;

var youtube = function youtube() {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: "29",
    height: "20",
    viewBox: "0 0 29 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M27.9764 16.8705C27.6472 18.0942 26.6824 19.0589 25.4588 19.3884C23.2235 20 14.2821 20 14.2821 20C14.2821 20 5.34111 20 3.10581 19.4116C1.90578 19.0824 0.917412 18.094 0.588246 16.8705C0 14.6354 0 10 0 10C0 10 0 5.34128 0.588246 3.12952C0.917761 1.90596 1.88225 0.941297 3.10599 0.611782C5.36465 -6.755e-07 14.2825 -6.755e-07 14.2825 -6.755e-07C14.2825 -6.755e-07 23.2235 -6.32935e-07 25.4588 0.588419C26.6825 0.91776 27.6472 1.88242 27.9767 3.10598C28.5648 5.34128 28.5648 9.97646 28.5648 9.97646C28.5648 9.97646 28.5883 14.6354 27.9764 16.8705V16.8705ZM11.4354 5.7177V14.2823L18.8706 10L11.4354 5.7177Z",
    fill: "#262F56"
  }));
};

exports.youtube = youtube;

var label = function label() {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: "11",
    height: "20",
    viewBox: "0 0 11 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.4254 0.00416133L7.82696 0C4.90772 0 3.02118 1.9319 3.02118 4.92203V7.19141H0.408577C0.182818 7.19141 0 7.37409 0 7.59943V10.8875C0 11.1128 0.183026 11.2953 0.408577 11.2953H3.02118V19.5922C3.02118 19.8175 3.20399 20 3.42975 20H6.83845C7.06421 20 7.24703 19.8173 7.24703 19.5922V11.2953H10.3018C10.5275 11.2953 10.7103 11.1128 10.7103 10.8875L10.7116 7.59943C10.7116 7.49123 10.6684 7.38762 10.5919 7.31105C10.5154 7.23448 10.4112 7.19141 10.3028 7.19141H7.24703V5.26763C7.24703 4.34298 7.46778 3.87358 8.67455 3.87358L10.425 3.87295C10.6505 3.87295 10.8333 3.69027 10.8333 3.46514V0.411972C10.8333 0.187052 10.6507 0.00457747 10.4254 0.00416133Z",
    fill: "#262F56"
  }));
};

exports.label = label;

var facebookBW = function facebookBW() {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: "9",
    height: "16",
    viewBox: "0 0 9 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8.66109 0.00332907L6.5024 0C4.07718 0 2.5099 1.54552 2.5099 3.93762V5.75313H0.339433C0.151879 5.75313 0 5.89927 0 6.07954V8.71001C0 8.89028 0.152052 9.03625 0.339433 9.03625H2.5099V15.6738C2.5099 15.854 2.66178 16 2.84933 16H5.68118C5.86873 16 6.02061 15.8539 6.02061 15.6738V9.03625H8.55839C8.74595 9.03625 8.89782 8.89028 8.89782 8.71001L8.89886 6.07954C8.89886 5.99299 8.86302 5.91009 8.79946 5.84884C8.7359 5.78758 8.64931 5.75313 8.55926 5.75313H6.02061V4.2141C6.02061 3.47438 6.20401 3.09886 7.20655 3.09886L8.66074 3.09836C8.84812 3.09836 9 2.95222 9 2.77211V0.329578C9 0.149642 8.84829 0.00366197 8.66109 0.00332907Z",
    fill: "black"
  }));
};

exports.facebookBW = facebookBW;

var instagramBW = function instagramBW() {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M0.269531 7.46953C0.269531 4.46974 0.269531 2.96985 1.03346 1.91839C1.28018 1.57881 1.57881 1.28018 1.91839 1.03346C2.96985 0.269531 4.46974 0.269531 7.46953 0.269531H8.80082C11.8006 0.269531 13.3005 0.269531 14.352 1.03346C14.6915 1.28018 14.9902 1.57881 15.2369 1.91839C16.0008 2.96985 16.0008 4.46974 16.0008 7.46953V8.80082C16.0008 11.8006 16.0008 13.3005 15.2369 14.352C14.9902 14.6915 14.6915 14.9902 14.352 15.2369C13.3005 16.0008 11.8006 16.0008 8.80082 16.0008H7.46953C4.46974 16.0008 2.96985 16.0008 1.91839 15.2369C1.57881 14.9902 1.28018 14.6915 1.03346 14.352C0.269531 13.3005 0.269531 11.8006 0.269531 8.80082V7.46953ZM8.13347 3.9712C5.83381 3.9712 3.96931 5.8357 3.96931 8.13536C3.96931 10.435 5.83381 12.2995 8.13347 12.2995C10.4331 12.2995 12.2976 10.435 12.2976 8.13536C12.2976 5.8357 10.4331 3.9712 8.13347 3.9712ZM8.13347 10.738C6.69892 10.738 5.53087 9.56991 5.53087 8.13536C5.53087 6.69976 6.69892 5.53276 8.13347 5.53276C9.56803 5.53276 10.7361 6.69976 10.7361 8.13536C10.7361 9.56991 9.56803 10.738 8.13347 10.738ZM13.1679 3.6592C13.1679 3.96565 12.9195 4.21408 12.6131 4.21408C12.3066 4.21408 12.0582 3.96565 12.0582 3.6592C12.0582 3.35275 12.3066 3.10433 12.6131 3.10433C12.9195 3.10433 13.1679 3.35275 13.1679 3.6592Z",
    fill: "black"
  }));
};

exports.instagramBW = instagramBW;

var linkedinBW = function linkedinBW() {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.2298 13.2317V13.2311H13.2331V8.37845C13.2331 6.00449 12.722 4.17578 9.9467 4.17578C8.61251 4.17578 7.71718 4.90793 7.35166 5.60203H7.31307V4.39741H4.68164V13.2311H7.42167V8.85699C7.42167 7.7053 7.64 6.59164 9.06625 6.59164C10.4715 6.59164 10.4925 7.90597 10.4925 8.93087V13.2317H13.2298Z",
    fill: "black"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M0.220703 4.39648H2.96404V13.2302H0.220703V4.39648Z",
    fill: "black"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1.58889 0C0.711746 0 0 0.711746 0 1.58889C0 2.46603 0.711746 3.19266 1.58889 3.19266C2.46603 3.19266 3.17777 2.46603 3.17777 1.58889C3.17722 0.711746 2.46547 0 1.58889 0V0Z",
    fill: "black"
  }));
};

exports.linkedinBW = linkedinBW;

var twitterBW = function twitterBW() {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: "18",
    height: "14",
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18 1.65642C17.3375 1.93751 16.6266 2.12814 15.8798 2.21324C16.6424 1.77597 17.2261 1.08239 17.5028 0.258473C16.7875 0.663419 15.9978 0.957461 15.1565 1.11686C14.4828 0.428658 13.5244 0 12.4615 0C10.4223 0 8.76881 1.5832 8.76881 3.53473C8.76881 3.81151 8.80143 4.08184 8.86443 4.34034C5.79601 4.19277 3.07515 2.78514 1.25412 0.646183C0.935796 1.16747 0.754707 1.77487 0.754707 2.42325C0.754707 3.64997 1.40709 4.73236 2.39692 5.36562C1.79177 5.34624 1.22262 5.18684 0.724354 4.92189V4.96605C0.724354 6.67849 1.99762 8.10766 3.68592 8.43294C3.37659 8.51264 3.05042 8.5568 2.71297 8.5568C2.47453 8.5568 2.24394 8.53418 2.01786 8.49109C2.488 9.89659 3.85127 10.9187 5.46648 10.9467C4.20333 11.8944 2.61062 12.4577 0.880707 12.4577C0.582648 12.4577 0.289059 12.4405 0 12.4093C1.63433 13.4141 3.57459 14 5.65995 14C12.4525 14 16.1655 8.61281 16.1655 3.94077L16.1531 3.48305C16.8786 2.98759 17.5062 2.3651 18 1.65642Z",
    fill: "black"
  }));
};

exports.twitterBW = twitterBW;

var mailBW = function mailBW() {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    version: "1.0",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "22",
    viewBox: "0 0 32.000000 32.000000",
    preserveAspectRatio: "xMidYMid meet"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(0.000000,32.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20 170 l0 -110 140 0 140 0 0 110 c0 61 -3 110 -6 110 -4 0 -35 -20 -70 -46 l-64 -45 -64 45 c-35 26 -66 46 -70 46 -3 0 -6 -49 -6 -110z m96 -12 l44 -31 44 31 c24 18 47 32 50 32 3 0 6 -25 6 -55 l0 -55 -100 0 -100 0 0 55 c0 30 3 55 6 55 3 0 26 -14 50 -32z"
  })));
};

exports.mailBW = mailBW;

var youtubeBW = function youtubeBW() {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    height: "24pt",
    viewBox: "-21 -117 682.66672 682",
    width: "24pt",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "m626.8125 64.035156c-7.375-27.417968-28.992188-49.03125-56.40625-56.414062-50.082031-13.703125-250.414062-13.703125-250.414062-13.703125s-200.324219 0-250.40625 13.183593c-26.886719 7.375-49.03125 29.519532-56.40625 56.933594-13.179688 50.078125-13.179688 153.933594-13.179688 153.933594s0 104.378906 13.179688 153.933594c7.382812 27.414062 28.992187 49.027344 56.410156 56.410156 50.605468 13.707031 250.410156 13.707031 250.410156 13.707031s200.324219 0 250.40625-13.183593c27.417969-7.378907 49.03125-28.992188 56.414062-56.40625 13.175782-50.082032 13.175782-153.933594 13.175782-153.933594s.527344-104.382813-13.183594-154.460938zm-370.601562 249.878906v-191.890624l166.585937 95.945312zm0 0"
  }));
};

exports.youtubeBW = youtubeBW;

var svgData = function svgData() {
  return {
    facebook: facebook(),
    linkedin: linkedin(),
    youtube: youtube(),
    label: label(),
    twitter: twitter(),
    instagram: instagram()
  };
};

exports.svgData = svgData;

var svgBWData = function svgBWData() {
  return {
    facebook: facebookBW(),
    linkedin: linkedinBW(),
    twitter: twitterBW(),
    youtube: youtubeBW(),
    label: facebookBW(),
    instagram: instagramBW(),
    email: mailBW()
  };
};

exports.svgBWData = svgBWData;